import styled from "styled-components";

export const MediaContainer = styled.div`
  padding: 10px;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.colors.campaignCreationRightSideBar.containerBorderColor};
  background: ${({ theme }) => theme.colors.campaignCreationRightSideBar.containerBackgroundColor};

  &:empty {
    display: none;
  }
`;

export const ContainersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 300px;
  position: ${({ isMediaAsset }) => (isMediaAsset ? "" : "fixed")};
  right: 40px;
  top: 245px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 15px;
  border: 1px solid
    ${({ theme }) => theme.colors.campaignCreationRightSideBar.containerErrorBorderColor};
  background: ${({ theme }) =>
    theme.colors.campaignCreationRightSideBar.containerErrorBackgroundColor};

  &:empty {
    display: none;
  }
`;

export const ErrorTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ErrorMessage = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 1rem;
`;
